export default __webpack_public_path__ + "static/media/1responsive.797c3a7b.jpeg";